import React, {
	useEffect, useState
} from "react"
import {
	Modal, Form, DatePicker
} from "antd"
import locale from "antd/lib/date-picker/locale/ru_RU"
import moment, {
	now
} from "moment"
import "moment/locale/ru"
import 'antd/lib/date-picker/style/index.css'
import {
	useSelector
} from 'react-redux'
import {
	CustomInput
} from "../../../components/CustomInput"
import CustomButton from "../../../components/ButtonCustom"
import { i18n } from "../localization"
import Notifications from "../../../helpers/Notifications"

const ReReasonTypeChangeForm = (props) => {
	const isRu = useSelector(state => state.globalReducer.isRu)
	const { visible, setVisible, setResource, resource, create, update } = props
	const dateFormat = 'DD.MM.YYYY'
	const [form] = Form.useForm()

	useEffect(() => {
		if (resource) {
			form.setFieldsValue({
				code: resource.code,
				name: resource.name,
				nameBel: resource.nameBel,
				startDate: moment(resource.startDate, dateFormat)
			})
		}
	}, [resource])

	function handleCancel() {
		form.resetFields();
		setVisible(false)
		setResource(null)
	}
	const onFinish = values => {
		const updateValues = {
			id: resource?.id,
			code: values.code,
			name: values.name,
			nameBel: values.nameBel,
			startDate: values.startDate.format("YYYY-MM-DD"),
		}
		const previousValues = {
			id: resource?.id,
			code: resource?.code,
			name: resource?.name,
			nameBel: resource?.nameBel,
			startDate: resource?.startDate ? resource.startDate.format("YYYY-MM-DD") : ''
		}
		if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
			Notifications(i18n.messageDataNotChanged[isRu])
		else resource ? update(updateValues) : create(updateValues)
		handleCancel()
	}

	return (
		<div>
			<Modal
				destroyOnClose
				footer={null}
				title={resource ? i18n.titleModalEditItem[isRu] : i18n.titleModalAddItem[isRu]}
				visible={visible}
				width={900}
				onCancel={handleCancel}
			>
				<Form
					form={form}
					labelAlign="left"
					labelCol={{ span: 6 }}
					name="nsi-form"
					wrapperCol={{
						span: 16,
						offset: 1
					}}
					onFinish={onFinish}
				>
					<Form.Item
						label={i18n.tableHeaderCode[isRu]}
						name="code"
						rules={[
							{
								required: true,
								message: i18n.messageCodeValidate[isRu],
								pattern: /^\d{1,4}$/
							}
						]}
					>
						<CustomInput
							disabled={ Boolean(resource) }
							placeholder={i18n.tableHeaderCode[isRu]}
						/>
					</Form.Item>
					<Form.Item
						label={i18n.tableHeaderNameRu[isRu]}
						name="name"
						rules={[
							{
								required: true,
								min: 4,
								max: 200,
								message: function () {
									return i18n.messageNameRuValidate[isRu]
								}
							}
						]}
					>
						<CustomInput placeholder={i18n.tableHeaderNameRu[isRu]} />
					</Form.Item>
					<Form.Item
						label={i18n.tableHeaderNameBel[isRu]}
						name="nameBel"
						rules={[
							{
								required: true,
								min: 4,
								max: 200,
								message: i18n.messageNameBelValidate[isRu],
							}
						]}
					>
						<CustomInput placeholder={i18n.tableHeaderNameBel[isRu]} />
					</Form.Item>
					<Form.Item
						label={i18n.tableHeaderDateStart[isRu]}
						name="startDate"
						rules={[
							{
								required: true,
								message: i18n.messageDateStartValidate[isRu],
							}
						]}
					>
						<DatePicker
							format="DD.MM.YYYY"
							locale={locale}
							placeholder={i18n.tableHeaderDateStart[isRu]}
							style={{ width: "100%" }}
						/>
					</Form.Item>
					<Form.Item wrapperCol={{ span: 24 }}>
						<CustomButton
							htmlType="submit"
							type="orange"
						>
							{i18n.buttonSave[isRu]}
						</CustomButton>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	)
}
export default ReReasonTypeChangeForm
